// extracted by mini-css-extract-plugin
module.exports = {"root":"e_srb","loading":"e_trb"};